import React from 'react';

export const data = {
  title: "FAQs",
  rows: [
    {
      index: 0,
      title: <b>Are your calculations accurate?</b>,
      content: "You bet. We use the official CRA payroll calculator to do our calculations so the deductions will reflect the federal calculations."
    },
    {
      index: 1,
      title: <b>Do you backdate? </b>,
      content: 'We sure do. You can use OneTwoPay to catch up on pay stubs going back as far as three years. We recommend you always start with the first pay stub and then create them in order using the “Next Pay Stub” function on the My Pay Stubs page. Finalize each pay stub as you go to ensure you end up with the correct Year-To-Date (YTD) amounts.'
    },
    {
      index: 2,
      title: <b>What information do I need from my employee?  </b>,
      content: "You need their full name, address, and a completed TD1 form (provincial and federal), which can be found <a href='https://www.canada.ca/en/revenue-agency/services/forms-publications/td1-personal-tax-credits-returns/td1-forms-pay-received-on-january-1-later.html'> here</a> "
    }
  ]
};